jQuery(function($) {
    $(document).ready(function() {
        //debugger;
        initSliders();
        var annee, anneemax, anneemin;

        $('.wrapper-winners').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            //console.log("CurrentSlide:" + currentSlide, "nextSlide:" + nextSlide);
            if (currentSlide <= nextSlide) {
                annee = parseInt($('.winners-nav .snav__arw--right').attr('data-annee'));
                $('.winners-nav .snav__arw--right').attr('data-annee', annee + 1);
                $('.winners-nav .snav__arw--left').attr('data-annee', annee - 1);
                $('.snav__title').html('Les Lauréats ' + annee);
            } else {
                annee = parseInt($('.winners-nav .snav__arw--left').attr('data-annee'));
                $('.winners-nav .snav__arw--left').attr('data-annee', annee - 1);
                $('.winners-nav .snav__arw--right').attr('data-annee', annee + 1);
                $('.snav__title').html('Les Lauréats ' + annee);
            }
        });

        $('.wrapper-teams').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            //console.log("CurrentSlide:" + currentSlide, "nextSlide:" + nextSlide);
            if (currentSlide <= nextSlide) {
                annee = parseInt($('.teams-nav .snav__arw--right').attr('data-annee'));
                $('.teams-nav .snav__arw--right').attr('data-annee', annee + 1);
                $('.teams-nav .snav__arw--left').attr('data-annee', annee - 1);
                $('.snav__title').html('Les équipes ' + annee);
            } else {
                annee = parseInt($('.teams-nav .snav__arw--left').attr('data-annee'));
                $('.teams-nav .snav__arw--left').attr('data-annee', annee - 1);
                $('.teams-nav .snav__arw--right').attr('data-annee', annee + 1);
                $('.snav__title').html('Les équipes ' + annee);
            }
        });

        $('.team-main-nav .snav__arw--right').click(function(e) {
            e.preventDefault();
            annee = parseInt($(this).attr('data-annee'));
            anneemax = parseInt($(this).attr('data-annee-max'));
            if (anneemax >= annee) {
                if (anneemax === annee) {
                    $(this).addClass('slick-disabled');
                } else {
                    $(this).removeClass('slick-disabled');
                }
                $('.team-main-nav .snav__arw--left').removeClass('slick-disabled');
                $('.wrapper-challenges').slick('slickUnfilter');
                $('.wrapper-challenges').slick('slickFilter', '.filter-' + annee);
                $('.team-main-nav .snav__arw--right').attr('data-annee', annee + 1);
                $('.team-main-nav .snav__arw--left').attr('data-annee', annee - 1);
                $('.team-main-nav .snav__title').html('Les projets ' + annee);
                var slickIndex = $('.wrapper-challenges .slick-track:first-child').attr('data-slick-index');
                // console.log('slickIndex = '+slickIndex);
                $('.wrapper-challenges').slick('slickGoTo', slickIndex, true);
                // $('.wrapper-challenges').slick('slickGoTo', 0);
                $titre = $('.slick-active').attr('data-title');
                $('.team-snav .snav__title').html($titre);
            }
        });

        $('.team-main-nav .snav__arw--left').click(function(e) {
            e.preventDefault();
            annee = parseInt($(this).attr('data-annee'));
            anneemin = parseInt($(this).attr('data-annee-min'));
            if (anneemin <= annee) {
                if (anneemin === annee) {
                    $(this).addClass('slick-disabled');
                } else {
                    $(this).removeClass('slick-disabled');
                }
                $('.team-main-nav .snav__arw--right').removeClass('slick-disabled');
                $('.wrapper-challenges').slick('slickUnfilter');
                $('.wrapper-challenges').slick('slickFilter', '.filter-' + annee);
                $('.team-main-nav .snav__arw--left').attr('data-annee', annee - 1);
                $('.team-main-nav .snav__arw--right').attr('data-annee', annee + 1);
                $('.team-main-nav .snav__title').html('Les projets ' + annee);
                // var slickIndex = $('.wrapper-challenges .wrapper-single-team[data-annee="'+annee+'"]:first-child').attr('data-slick-index');
                // console.log('slickIndex = '+slickIndex);
                var slickIndex = $('.wrapper-challenges .slick-track:first-child').attr('data-slick-index');
                // $('.wrapper-challenges').slick("slickSetOption", 'waitForAnimate', false, false);
                $('.wrapper-challenges').slick('slickGoTo', slickIndex, true);
                // $('.wrapper-challenges').slick("slickSetOption", 'waitForAnimate', true, false);
                // $('.wrapper-challenges').slick('slickGoTo', 0);
                $titre = $('.slick-active').attr('data-title');
                $('.team-snav .snav__title').html($titre);

            }
        });

        $('.wrapper-challenges').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            //console.log("CurrentSlide:" + currentSlide, "nextSlide:" + nextSlide);
            //console.log(slick);
            $('.team-snav .snav__title').html(slick.$slides[nextSlide].getAttribute("data-title"));
        });

        // Filter by challenge page Teams + modify 
        $('.filter-challenge input').change(function() {
            var idChallenge = $(this).attr('id');
            // Height du contenu qui est retiré/ajouté
            var contentHeight = parseInt($('.wrapper-teams-list.slick-current .teams-list.' + idChallenge).height());
            var titleHeight = parseInt($('.wrapper-teams-list.slick-current .title-line.' + idChallenge).height());
            var totalHeight = contentHeight + titleHeight;
            var currentHeight;
            if ($('.' + idChallenge).css('display') == 'block') {
                currentHeight = $('.wrapper-teams-list.slick-current').height();
                $('.slick-list').height(currentHeight - totalHeight);
                $('.' + idChallenge).hide();
            } else {
                currentHeight = $('.wrapper-teams-list.slick-current').height();
                $('.slick-list').height(currentHeight + totalHeight);
                $('.' + idChallenge).show();
            }
        });

        // fancy box single projets
        // $("[data-fancybox]").fancybox({
        //     thumbs : {
        //         autoStart   : false,                  // Display thumbnails on opening
        //         hideOnClose : true,                   // Hide thumbnail grid when closing animation starts
        //         parentEl    : '#galery_fb',  // Container is injected into this element
        //         axis        : 'x'                     // Vertical (y) or horizontal (x) scrolling
        //     }
        // });
        $('a[data-fancybox="en-image"]').fancybox({
            thumbs : {
                autoStart : true,
                axis        : 'x'
            }
        });
        $('#galery_btn').on('click', function(e){
            e.preventDefault();
            console.log('galery fb button click');
            $('#galery_firstpic').click();
        });
        $('.fancybox-youtube').fancybox();
        if ($('body').hasClass('page-template-tpl_confirm_vote')){
            var param = unescape(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + escape('a').replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
            $.ajax({
                type: "post",
                url: '/wp/wp-admin/admin-ajax.php',
                data: {
                    'action': 'registerVote',
                    'data': param,
                },
                success: function (msg) {
                    if (msg === '0') {
                        $('.vote-denied').show();
                    }else{
                        $('.vote-confirmed').show();
                    }
                }
            });
        }



        $('#btn_acf_save_draft').on('click', function(e){
            console.log('click btn_acf_save_draft');
            // e.preventDefault();
            window.acf.validation.active = false;
            $('#acf-multiform').submit();
        });



    });

    // FONCTIONS/METHODES 

    /**
     * initSliders
     * @description : Initialisation des sliders du projet
     * @lib : slickjs
     */
    function initSliders() {

        $('.wrapper-challenges').on('init', function(event, slick, setPosition) {
            annee = $('.wrapper-single-team.current').attr('data-annee');
        });
        var initialSlideWinners;
        if ($('.winners-list.current')) {
            initialSlideWinners = $('.winners-list.current').index();
        } else {
            initialSlideWinners = 0;
        }
        $('.wrapper-winners').slick({
            infinite: false,
            speed: 300,
            accessibility: false,
            slidesToShow: 1,
            initialSlide: initialSlideWinners,
            prevArrow: $('.winners-nav .snav__arw--left'),
            nextArrow: $('.winners-nav .snav__arw--right'),
            adaptiveHeight: true
        });
        var initialSlideTeams;
        if ($('.wrapper-teams-list.current')) {
            initialSlideTeams = $('.wrapper-teams-list.current').index();
        } else {
            initialSlideTeams = 0;
        }
        console.log(initialSlideTeams);
        $('.wrapper-teams').slick({
            infinite: false,
            speed: 300,
            accessibility: false,
            slidesToShow: 1,
            initialSlide: initialSlideTeams,
            prevArrow: $('.teams-nav .snav__arw--left'),
            nextArrow: $('.teams-nav .snav__arw--right'),
            adaptiveHeight: true

        });

        // console.log(initialSlideChallenges);
        $('.wrapper-challenges').slick({
            infinite: false,
            speed: 300,
            accessibility: false,
            slidesToShow: 1,
            //initialSlide: initialSlideChallenges,
            prevArrow: $('.team-snav .snav__legend--left'),
            nextArrow: $('.team-snav .snav__legend--right'),
            adaptiveHeight: true
        });
        var annee = $('.wrapper-single-team.current').attr('data-annee');
        $('.wrapper-challenges').slick('slickFilter', '.filter-' + annee);
        var initialSlideChallenges;
        if ($('.wrapper-single-team.current')) {
            initialSlideChallenges = $('.wrapper-single-team').index($('.wrapper-single-team.current'));
        } else {
            initialSlideChallenges = 0;
        }
        $('.wrapper-challenges').slick('slickGoTo', initialSlideChallenges, true);
    }

    // Menu mobile
    $('#mobile_menu_btn').on('click', function() {
        $('#mobile_menu').toggleClass('active');
    });

    // Create templates for buttons

    $.fancybox.defaults.btnTpl.vote = '<button data-fancybox-tw class="btn btn-fancybox" onclick="openPopinVote()" title="Vote">' +
        'Je vote' +
        '</button>';

// Make buttons clickable using event delegation
    $('body').on('click', '[data-fancybox-vote]', function() {
        window.open("https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(window.location.href)+"&t="+encodeURIComponent(document.title), '','left=0,top=0,width=600,height=300,menubar=no,toolbar=no,resizable=yes,scrollbars=yes');
    });

// Custom options
    $( '[data-fancybox]' ).fancybox({
        buttons : [
            'vote',
            'close'
        ]
    });





});
